<cw-menu maxWidth="300px">
  <div slot="trigger">
    @if (image()) {
      <img class="user-avatar" [src]="image()" alt="profile" />
    } @else {
      @if (profile()) {
        <cw-avatar
          surface="onPrimary"
          avatar-type="letters"
          size="md"
          [firstName]="profile().firstName"
          [lastName]="profile().lastName"
        />
      }
    }
  </div>

  @if (profile()) {
    <div slot="header">
      <div class="user-info">
        <div>
          <h5 class="user-info-name">{{ profile().firstName }} {{ profile().lastName }}</h5>
          <div class="user-info-email">{{ profile().email }}</div>
        </div>
      </div>
    </div>
  }
  @for (site of sites(); track site.id) {
    <cw-menu-item
      menu-type="result"
      customShadowCss
      styles=".menu-item:hover{background: inherit !important}.result{padding:0 !important}"
    >
      <div class="user-unit-switch">
        <div class="user-unit-switch-label">
          {{ site.name }}
        </div>

        @for (unit of site.units; track unit.id) {
          <div
            class="user-unit-switch-item"
            [class.active]="userService?.context()?.unitId === unit.id"
            (click)="selectedContext({ unitId: unit.id, siteId: site.id })"
          >
            <cw-icon icon="organisations" size="sm" font="cortex" />
            <span class="user-unit-switch-item-name">
              {{ unit.name }}
            </span>
          </div>
        }
      </div>
    </cw-menu-item>
  }

  <cw-menu-item menu-type="result" (click)="toProfilePage()">
    <cw-icon icon="manage-accounts" size="sm" font="cortex" />
    <span>{{ 'ProfileSettings' | translate }}</span>
  </cw-menu-item>

  @if (isAdmin()) {
    <cw-menu-item menu-type="result" (click)="toOrganizationSettings()">
      <gplus-icon-organization-settings />
      <span>{{ 'OrganizationSettings' | translate }}</span>
    </cw-menu-item>
  }

  <cw-menu-item menu-type="result" (click)="logout()">
    <cw-icon icon="logout" size="sm" font="cortex" />
    <span>{{ 'LogOut' | translate }}</span>
  </cw-menu-item>
</cw-menu>
